import { InitialState } from "../Interfaces";

export const initialState: InitialState = {
  documentCategories: {
    data: [],
    isLoading: false,
  },

  entityInfo: {
    data: "",
    isLoading: false,
    keys: [],
  },

  caseAssignmentResult: {
    data: null,
    keys: [],
    isLoading: false,
    mappedDocumentsIds: [],
  },
};
